import * as actionTypes from '../constants/actionTypes';
import OrdersApi from '../api/orders/ordersApi';

export function showModal() {
  return (dispatch, getState) => {
    const allowOrdering = getState().appConfig.allowOrdering;
    if (allowOrdering) {
      dispatch({ type: actionTypes.ORDER_MODAL_SHOW });
    }
    else {
      dispatch({ type: actionTypes.SUBSCRIPTION_MODAL_SHOW });
    }
  };
}

export function hideModal() {
  return { type: actionTypes.ORDER_MODAL_HIDE };
}

export function changePaymentType(paymentType) {
  return {type: actionTypes.ORDER_PAYMENT_TYPE_CHANGE, paymentType};
}

export function createOrder(order) {
  return dispatch => {
    dispatch({type: actionTypes.ORDER_CREATE, order});

    return OrdersApi.create(order)
      .then(order => { return dispatch(createOrderSuccess(order));})
      .catch(err => { dispatch(createOrderFailure(err)); throw err;});
  };
}

export function createOrderSuccess(order) {
  return { type: actionTypes.ORDER_CREATE__SUCCESS, order };
}

export function createOrderFailure(err) {
  return { type: actionTypes.ORDER_CREATE__FAILURE, err };
}

export function confirmOrder(orderId, code) {
  return dispatch => {
    return OrdersApi.confirm(orderId, code).then(({success}) => {
      if (success) {
        return dispatch(confirmOrderSuccess());
      }
      else {
        dispatch(confirmOrderFailure());
        throw Error('Uncorrect confirmation code');
      }
    });
  };
}

export function confirmOrderSuccess() {
  return { type: actionTypes.ORDER_CONFIRM__SUCCESS };
}

export function confirmOrderFailure() {
  return { type: actionTypes.ORDER_CONFIRM__FAILURE };
}

export function confirmOrderCancel() {
  return { type: actionTypes.ORDER_CONFIRM__CANCEL };
}

export function cleanOrder() {
  return { type: actionTypes.ORDER_CLEAN };
}



// WEBPACK FOOTER //
// ./src/actions/orderActions.js